var Exigo = {
  Settings: {
    backendUrl:"https://api-office.theonglobal.com/", //our
    selfClientId:302667, //our
    typeOfAffiliate:3, //our
    typeOfCustomer:1, //our,
    BackofficeUrl:"https://backoffice.theonglobal.com/auth", //our
    refUrl:"https://theonglobal.com?ref=", //our
    ShopUrl: "d6e995-4.myshopify.com",
    // ApiUrl: "https://theonshopifyplugin.azurewebsites.net",
    // BackofficeUrl: "https://backoffice.theonglobal.com/",
    // SilentLoginUrl: "/account/silentlogin?token=",
    // StorePublicUrl: "https://theonglobal.com",
    // CheckoutUrl: "",//"https://localhost:44348",
    // DebugCheckoutUrl: "https://localhost:44341",
    // DebugApiUrl: "https://localhost:44341",
    SharedKey: "kjhbsjdahsvdiuysgd761521j2hwv1ys",
    ReferralCookieName: "refId",
    // LoginCookie: "ExigoSilentLogin",
    // SyncCookie: "ExigoCustomerSyncing",
    ReferralParameter: "ref",
    DefaultWebalias: "theonglobal",
    // EnableEnrollerSearch: true,
    // RetailCustomerType: 1,
    // AffiliatePoints: {
    //   UseAffiliatePoints: true,
    // },
    // Enrollment:{
    //   Enable: true,
    //   ForceEnrollmentFlow: true
    // }
  },
  Actions: {
    SetEnrollerSearch: function() {
      setEnrollerSearch();
    },
    AddReferralToUrl: function() {
      addReferralToUrl();
    },
    SearchForEnroller: function(query){
      searchForEnroller(query);
    },
    Checkout: {
      GetProductPrices: function(priceType, sku){
        getProductPrices(priceType, sku);
      },
      CalculateCart: function(priceType, cartType) {
        calculateCart(priceType, cartType);
      }
    },
    AffiliatePoints: {
      GetPoints: function(callback){
        getPoints(callback);
      },
      SpendPoints: function(value){
        addPointsToCart(value);
      },
      GetEligibleRewards: function(callback){
        getEligibleRewards(callback);
      },
      GetAllEligibleRewards: function(callback){
        getAllEligibleRewards(callback);
      },
      GetAllAffiliateRewards: function(callback){
        getAllAffiliateRewards(callback);
      },
      CreateAffiliateReward: function(callback, id){
        createAffiliateReward(callback, id);
      }
    }
  },
  Initialize: function(){
    initialize();
  }
}
Exigo.Initialize();


//Basic Functions
var exigoSilentLoginToken;
var storePublicUrl;
var silentLoginUrl;
var backofficeUrl;
var silentLoginUrl;
var sharedKey;
var referralCookieName;
var loginCookie;
var syncCookie = "ExigoCustomerSyncing";
var referralParameter;
var apiUrl;
var priceType = 1;
var priceTypeWithCurrency;
var isDebug = 0;
var checkoutUrl;
var debugCheckoutUrl;
var shopUrl;
var defaultWebalias;
var debugApiUrl;
var enableEnrollerSearch;
var useCheckout;
var useEnrollment;
var forceEnrollmentFlow;
var useCheckoutForEnrollment;
var useCheckoutForSubscriptions;
var cartFormId;
var clearCartbyParameter;
var hasClearCartShopifyPage;
var restrictEnrollmentKits;
var enrollmentKitsAllowed;
var currentLocationNoRef;
var pointsAvailable;
function getCookie(cname) {
  let name = cname + "=";
  let decodedCookie = decodeURIComponent(document.cookie);
  let ca = decodedCookie.split(';');
  for (let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) == ' ') {
          c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
          return c.substring(name.length, c.length);
      }
  }
  return Exigo.Settings.DefaultWebalias;
}
function setEnroller() {
  var referral = getCookie(referralCookieName).toLowerCase()
  fetch('/cart/update.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
          'Content-Type': 'application/json',
      },
      body: JSON.stringify({ attributes: { "Referral": referral } }),
  });
}
function addReferralToUrl() {
  var refId = getCookie(referralCookieName);
  var links = document.querySelectorAll("a");
  for (var i = 0; i < links.length; i++) {
      var link = links[i].getAttribute("href");
      if (link != null) {
          var href = removeURLParameter(link, referralParameter)
          links[i].href = addUrlParameter(href, referralParameter + "=" + refId);
          var setClass = links[i].classList;
          if(setClass.contains("referral-link")){
            links[i].innerHTML = addUrlParameter(href, referralParameter + "=" + refId);
          }
      }
  }
}
// function setReferralCookie() {
//   var ref = getUrlVars()[referralParameter];
//   console.log("iscustomer: " + isCustomer);
//   if(isCustomer && exigoCustomerTypeId > 1) {
//     console.log("Iscustomer");
//     if(ref == undefined)
//     {
//       if(exigoWebalias && exigoWebalias !== "") {
//         var separator = window.location.href.indexOf('?') !== -1 ? '&' : '?';
//         var url = window.location.href + separator + "ref=" + exigoWebalias;
//         if(url.toLowerCase() !== window.location.href.toLowerCase()) {
//           console.log("Redirect To Url as ref is empty: " + url);
//           window.location = url;
//           return;
//         }
//       }
//     }
//     else if(ref != exigoWebalias)
//     {
//       var url = window.location.href.toLowerCase().replace(ref.toLowerCase(), exigoWebalias);
//       if(url !== window.location.href.toLowerCase()) {
//         console.log("Redirect To Url as ref is none match: " + url);
//         window.location = url;
//         return;
//       }
//     }
//      ref = exigoWebalias;
//   } else if(isCustomer) {
//      ref = _referral;
//   }
//   if (ref != undefined) {
//       var expires = "";
//       var date = new Date();
//       date.setTime(date.getTime() + (30 * 24 * 60 * 60 * 1000));
//       expires = "; expires=" + date.toUTCString();
//       document.cookie = referralCookieName + "=" + ref + expires + "; path=/";
//   }
// }

function setReferralCookie() {
  var urlRef = getUrlVars()[referralParameter]; // usually "ref"
  console.log("iscustomer: " + isCustomer);

  // Normalize values
  var mfReferral = (_referral || "").trim();        // enroller webalias (what you want)
  var cookieRef  = (getCookie(referralCookieName) || "").trim();
  var fallback   = (defaultWebalias || Exigo.Settings.DefaultWebalias || "theonglobal").trim();

  var ref;

  if (isCustomer) {
    // ✅ For BOTH customers and affiliates: use their enroller if present
    if (mfReferral) {
      ref = mfReferral;
    } else if (urlRef) {
      ref = decodeURIComponent(urlRef).trim();
    } else if (cookieRef) {
      ref = cookieRef;
    } else {
      ref = fallback;
    }

    // ✅ Ensure URL ref matches what we resolved (avoid full reload)
    try {
      var u = new URL(window.location.href);
      if (u.searchParams.get(referralParameter) !== ref) {
        u.searchParams.set(referralParameter, ref);
        window.history.replaceState({}, "", u.toString());
      }
    } catch (e) {
      // ignore
    }

  } else {
    // Guest: keep existing behavior (URL -> cookie -> default)
    if (urlRef) {
      ref = decodeURIComponent(urlRef).trim();
    } else if (cookieRef) {
      ref = cookieRef;
    } else {
      ref = fallback;
    }
  }

  // ✅ Always set cookie (so later code gets a stable value)
  if (ref) {
    var date = new Date();
    date.setTime(date.getTime() + (30 * 24 * 60 * 60 * 1000));
    var expires = "; expires=" + date.toUTCString();
    document.cookie = referralCookieName + "=" + encodeURIComponent(ref) + expires + "; path=/";
  }
}

// function getUrlVars() {
//     var vars = [], hash;
//     var hashes = window.location.href.slice(window.location.href.indexOf('?') + 1).split('&');
//     for (var i = 0; i < hashes.length; i++) {
//         hash = hashes[i].split('=');
//         vars.push(hash[0]);
//         vars[hash[0]] = hash[1];
//     }
//     return vars;
// }


function getUrlVars() {
    var vars = [];
    var params = new URLSearchParams(window.location.search);
    params.forEach(function(value, key) {
        vars.push(key);
        vars[key] = value;
    });
    return vars;
}

// function setEnrollerSearchLogic() {
//   $('[data-role="search-enroller"]').on("click", function(){
//     $(".enroller-search-container").show();
//     $(".enroller-box").hide();
//   });
//   $(window).click(function() {
//     $('#enrollerSearchResult').hide();
//   });
//   $('#searchEnrollerInput').on("focus", function(event){
//     if($(this).val() != "")
//     {
//       $('#enrollerSearchResult').show();
//     }
//   });
//   $('#searchEnrollerInput').click(function(event){
//     event.stopPropagation();
//   });
//   $('#enrollerSearchResult').click(function(event){
//     event.stopPropagation();
//   });
  
//   $('#searchEnrollerInput').keyup(delay(function (e) {
//     var query = $(this).val();
//     if(query == "") {
//       $("#enrollerSearchResult").hide();
//     } else if(query.length > 2){
//       searchForEnroller(query);
//     }
//   }, 500));
//   var ref = getCookie(referralCookieName);
//   if(isCustomer){
//     ref = _referral;
//   } 
//  $.ajax({
//    url: Exigo.Settings.backendUrl + 'api/customer/GetEnroller?webalias=' + encodeURIComponent(ref) +
//   //url: 'https://theon-global-development.myshopify.com/apps/customer-api/GetEnroller?webalias=' + encodeURIComponent(ref) +
//        "&selfClientId=" + encodeURIComponent(Exigo.Settings.selfClientId),
//   type: "GET",
//   success: function (response) {
   

//     // ✅ Normalize/validate values
//     var returnedAlias = (response.webAlias || "").trim();
//     var currentAlias  = (ref || "").trim();

//     // ✅ If backend corrected the alias (invalid ref => fallback to 100000 or case normalization)
//     if (returnedAlias && currentAlias && returnedAlias.toLowerCase() !== currentAlias.toLowerCase()) {

//       // 1) Update cookie so everything else (links/cart/etc.) uses correct alias
//       setCookie(referralCookieName, returnedAlias);

//       // 2) Update URL param safely WITHOUT reloading (prevents UI flash + avoids loops)
//       try {
//         var u = new URL(window.location.href);
//         u.searchParams.set(referralParameter, returnedAlias);
//         window.history.replaceState({}, "", u.toString());
//       } catch (e) {
//         // If URL API isn't available, we still fixed cookie. That's enough.
//       }

//       // 3) Update local variable to keep logic consistent below
//       ref = returnedAlias;
//     }

//     // ---- Your existing UI rendering stays the same ----
//     var enrollersearch = document.getElementById("enrollerSearch");
//     if (enrollersearch != undefined) {
//       var source = document.getElementById("enroller-id-template").innerHTML;
//       var template = Handlebars.compile(source);
//       $("#enrollerInfo").html(template(response));
//     }

//     if (response.customerId != 2) {
//       $(".exigo-shopping-with").show();
//       $(".exigo-shopping-with-id").html(response.firstName + " " + response.lastName);
//     }
//   }
// });
// }


function setEnrollerSearchLogic() {
  console.log("setEnrollerSearchLogic")
  $('[data-role="search-enroller"]').on("click", function(){
    $(".enroller-search-container").show();
    $(".enroller-box").hide();
  });
  $(window).click(function() {
    $('#enrollerSearchResult').hide();
  });
  $('#searchEnrollerInput').on("focus", function(event){
    if($(this).val() != "")
    {
      $('#enrollerSearchResult').show();
    }
  });
  $('#searchEnrollerInput').click(function(event){
    event.stopPropagation();
  });
  $('#enrollerSearchResult').click(function(event){
    event.stopPropagation();
  });
  
  $('#searchEnrollerInput').keyup(delay(function (e) {
    var query = $(this).val();
    if(query == "") {
      $("#enrollerSearchResult").hide();
    } else if(query.length > 2){
      searchForEnroller(query);
    }
  }, 500));
  var ref = getCookie(referralCookieName);
  if(isCustomer){
    ref = _referral;
  } 

 $.ajax({
  //url: 'https://theon-global-development.myshopify.com/apps/customer-api/GetEnroller?webalias=' + encodeURIComponent(ref) +
   url: Exigo.Settings.backendUrl + 'api/customer/GetEnroller?webalias=' + encodeURIComponent(ref) +
       "&selfClientId=" + encodeURIComponent(Exigo.Settings.selfClientId),
  type: "GET",
    headers: {
    "X-Is-Logged-In": String(isLoggedIn)
  },
  success: function (response) {
   

    // ✅ Normalize/validate values
    var returnedAlias = (response.webAlias || "").trim();
    var currentAlias  = (ref || "").trim();

    // ✅ If backend corrected the alias (invalid ref => fallback to 100000 or case normalization)
    if (returnedAlias && currentAlias && returnedAlias.toLowerCase() !== currentAlias.toLowerCase()) {

      // 1) Update cookie so everything else (links/cart/etc.) uses correct alias
      setCookie(referralCookieName, returnedAlias);

      // 2) Update URL param safely WITHOUT reloading (prevents UI flash + avoids loops)
      try {
        // var u = new URL(window.location.href);
        // u.searchParams.set(referralParameter, returnedAlias);
        // u.hash = ""; 
        // window.history.replaceState({}, "", u.toString());

         var u = new URL(window.location.href);
        u.searchParams.set(referralParameter, returnedAlias);
        u.hash = "";
        var newUrl = u.toString();

        // Only reload if the URL is actually changing (prevents infinite reload loop)
        if (newUrl !== window.location.href) {
          window.location.replace(newUrl);
          return; // stop here — page is reloading, no need to continue this callback
        }
      } catch (e) {
        // If URL API isn't available, we still fixed cookie. That's enough.
      }

      // 3) Update local variable to keep logic consistent below
      ref = returnedAlias;
    }

    // ---- Your existing UI rendering stays the same ----
    var enrollersearch = document.getElementById("enrollerSearch");
    if (enrollersearch != undefined) {
      var source = document.getElementById("enroller-id-template").innerHTML;
      var template = Handlebars.compile(source);
      $("#enrollerInfo").html(template(response));
    }

    if (response.customerId != 2) {
      $(".exigo-shopping-with").show();
      $(".exigo-shopping-with-id").html(response.firstName + " " + response.lastName);
    }
  }
});
}






// function getEnroller(callback) {
//   var isEnrollment = getUrlVars()["isenrollment"];
//   $.ajax({
//     url: apiUrl + '/api/context/GetEnroller?webalias=' + getCookie(referralCookieName) + "&shopUrl=" + shopUrl,
//     type: "GET",
//     success: function(response){
//       if(response == undefined && !isEnrollment){
//         alert("The referral id used is not found in our database. Please search for your referral!")
//         var expires = "";
//         var date = new Date();
//         date.setTime(date.getTime() + (30 * 24 * 60 * 60 * 1000));
//         expires = "; expires=" + date.toUTCString();
//         document.cookie = referralCookieName + "=" + defaultWebalias + expires + "; path=/";
//         var refParam = getUrlVars()[referralParameter];
//         if(refParam) {
//           var url = location.href.toLowerCase().replace(refParam.toLowerCase(), defaultWebalias);
//           if(url !== location.href.toLowerCase()) {
//             window.location = url;
//             return;
//           }
//         }
//       }
//       callback(response);
//     },
//     error: function(){
//     }
//   });
// }


function searchForEnroller(query){
  setTimeout(function(){
    $("#enrollerSearchResult").show();
    var currentWebalias = getCookie("refId");
    $.ajax({
      url: apiUrl + '/api/context/EnrollerSearch?query=' + query + "&shopUrl=" + shopUrl,
      type: "GET",
      success: function(response){
        if(response.length == 0) {
          $("#enrollerSearchResult").html('<span class="enroller-no-result">Translation missing: en.enrollersearch.general.no_results</span>');
        } else {
          var source = document.getElementById("search-result-template").innerHTML;
          var html= "";


          // $.each(response, function(i,item){
          //   console.log(item);
          //   var url = "";
          //   if(location.href.includes("ref=")) {
          //     url = location.href.replace(currentWebalias, item.webAlias);
          //   } else {
          //     url = location.href + "?ref=" + item.webAlias;
          //   }
          //   console.log(url);
          //   item["link"] = url;
          // });
              $.each(response, function(i,item){
                var u = new URL(location.href);
                u.searchParams.set(referralParameter, item.webAlias);
                item["link"] = u.toString();
          });
          
          var template = Handlebars.compile(source);
          $("#enrollerSearchResult").html(template(response));
        }
      }
    });
  }, 500);
}
function setCookie(cName, value) {
    var expires = "";
    var date = new Date();
    date.setTime(date.getTime() + (30 * 24 * 60 * 60 * 1000));
    expires = "; expires=" + date.toUTCString();
    document.cookie = cName + "=" + value + expires + "; path=/";
}
function addUrlParameter(url, param) {
  var firstLetter = Array.from(url)[0];
  if(firstLetter != "#") {
    if (url != null && url.includes("?")) {
        url = url + '&';
    } else {
        url = url + '?';
    }
    url = url + param;
  }
  return url;
}
function insertNotesCreateCustomerForm() {
    var form = document.getElementById("create_customer");
    if (form != undefined) {
        var refId = getCookie(referralCookieName);
        var refInput = document.createElement("input");
        refInput.setAttribute("type", "hidden");
        refInput.setAttribute("name", "customer[note][referral]");
        refInput.setAttribute("value", refId);
        form.prepend(refInput)
    }
}
function setDebugCookie() {
    var debug = getUrlVars()["debugsession"];
    if (debug != null) {
        setCookie("debugsession", debug);
    } else {
        var debugCookie = getCookie("debugsession");
        if (debugCookie == "") {
            setCookie("debugsession", "0");
        }
    }
}
function removeURLParameter(url, parameter) {
    if (url != null) {
        var urlparts = url.split('?');
        if (urlparts.length >= 2) {

            var prefix = encodeURIComponent(parameter) + '=';
            var pars = urlparts[1].split(/[&;]/g);
            for (var i = pars.length; i-- > 0;) {
                if (pars[i].lastIndexOf(prefix, 0) !== -1) {
                    pars.splice(i, 1);
                }
            }
            return urlparts[0] + (pars.length > 0 ? '?' + pars.join('&') : '');
        }
        return url;
    }
}
function delay(callback, ms) {
    var timer = 0;
    return function () {
        var context = this, args = arguments;
        clearTimeout(timer);
        timer = setTimeout(function () {
            callback.apply(context, args);
        }, ms || 0);
    };
}
function setDebug(){
    isDebug = getCookie("debugsession");
    if (isDebug == "2") {
      apiUrl = debugApiUrl;
      checkoutUrl = debugCheckoutUrl;
      $("#devbox").show();
    } else if (isDebug == "1") {
      apiUrl = debugApiUrl;
      $("#devbox").show();
    }
}
function setEnrollerSearch() {
  var referral = getCookie(referralCookieName).toLowerCase()
  if (referral != defaultWebalias.toLowerCase()) {
      fetch('/cart/update.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: {
              'Content-Type': 'application/json',
          },
          body: JSON.stringify({ attributes: { "Referral": referral } }),
      });
  }
}
function setEventListeners(){
  //Create Customer logic
  jQuery(function () {
      jQuery('#create_customer').submit(function (event) {
          event.preventDefault();
          var data = jQuery(this).serialize();

          //create new account
          jQuery.post('/account', data)
              .done(function (data) {
                  var logErrors = jQuery(data).find('.errors').text();

                  //if there are errors show them in the html form
                  if (logErrors != "" && logErrors != 'undefined') {
                      jQuery('#create_customer .errors').html(logErrors);
                      jQuery('#create_customer .errors').show();

                      //if account creation is successful show checkout page
                  } else {
                      document.location.href = '/account';
                  }
              }).fail(function () { console.log('error'); });
          return false;
      });
  });
}
function getLoginCookie() {
    let name = loginCookie + "=";
    let decodedCookie = decodeURIComponent(document.cookie);
    let ca = decodedCookie.split(';');
    for (let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) == ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
        }
    }
    return "";
}
function setLoginCookie(value) {
    var expires = "";
    var date = new Date();
    date.setTime(date.getTime() + (25 * 60 * 1000000));
    expires = "; expires=" + date;
    document.cookie = loginCookie + "=" + value + expires + "; path=/";
}
function deleteLoginCookie() {
    var expires = "";
    var date = new Date();
    date.setTime(date.getTime() - (25 * 60 * 10000000));
    expires = "; expires=" + date;
    document.cookie = loginCookie + "=" + expires + "; path=/";
}
// function refreshLoginCookie(){
//   console.log("RefreshLogin:", isCustomer);
//   if(isCustomer){
//     const tokenRefreshed = new Event('tokenRefreshed');
//     var token = "";
//     if(token == ""){
//       var data = {
//         shopId: customerId,
//         sharedKey: sharedKey,
//         shopUrl: shopUrl
//       }
//       $.ajax({
//         url: apiUrl + '/api/authentication/RefreshAdminLoginToken',
//         type: "GET",
//         data: data,
//         success: function(response){
//           console.log(response);
//           token = response.token;
//           setLoginCookie(response);
//           window.dispatchEvent(tokenRefreshed);
//           if(response.customerTypeId > 1)
//           {
//             $(".silenlogin-menuitem").show();
//             $(".silentlogin").each(function(){
//                 href = backofficeUrl + "silentlogin?token=" + token;
//                 $(this).attr("href", href);
//                 $(this).show();
//             })
//             if(response.customerStatusId == 5) {
//               console.log("open modal");
//               document.getElementById('completeSignupModal').style.display = 'block';
//             }
//           }
//         }
//       });
//     } else {
//       var data = {
//         shopUrl: shopUrl,
//         token: token
//       }
//       $.ajax({
//         url: apiUrl + '/api/authentication/ValidateToken',
//         type: "GET",
//         data: data,
//         success: function(response){
//           if(response) {
//             window.dispatchEvent(tokenRefreshed);
//           $(".silentlogin").each(function(){
//               href = backofficeUrl + "silentlogin?token=" + token;
//               $(this).attr("href", href);
//               $(this).show();
//           })
//           } 
//         },
//         error: function(){
//             setLoginCookie("");
//             refreshLoginCookie();
//         }
//       });
//     }
//   } else{
//       setLoginCookie("");
//   }
// }

function refreshLoginCookie() {
    console.log("RefreshLogin:", isCustomer);

    if (!isCustomer) {
        setLoginCookie("");
        return;
    }

    const tokenRefreshed = new Event('tokenRefreshed');
    let token = ""; // You may want to get existing token from cookie if needed

    const data = {
        customerId: customerId // add if needed for multi-tenant
    };

    $.ajax({
        url: Exigo.Settings.backendUrl + 'api/auth/refresh-login-token',   // ← New endpoint
        type: "GET",
        data: data,
        success: function(response) {
            console.log("Refresh Login Response:", response);

            token = response.data.token;
            console.log("token : ",token);
            setLoginCookie(response);   // Make sure this still works with new structure

            window.dispatchEvent(tokenRefreshed);

            const typeId = response.data.customerTypeId || 1;
            const statusId = response.data.statusId || response.status;
          console.log("typeId : ",typeId);
          console.log("statusId : ",statusId);
            // Silent Login UI for Affiliates + Advanced Customers
            if (typeId > 1) {
                $(".silenlogin-menuitem").show();

                $(".silentlogin").each(function() {
                    const href = backofficeUrl +"?token=" + token;
                    $(this).attr("href", href);
                    $(this).show();
                });

                // Show Complete Signup Modal for Pending KYC Affiliates
                if (typeId === 3 && statusId === 3) {
                    console.log("Opening complete signup modal (Pending KYC)");
                    document.getElementById('completeSignupModal').style.display = 'block';
                }
            }
        },
        error: function(err) {
            console.error("Refresh login failed", err);
            setLoginCookie("");
            // Optional: retry once or redirect to login
        }
    });
}


function setSyncCookie(value) {
    var expires = "";
    var date = new Date();
    date.setTime(date.getTime() + (25 * 60 * 1000000));
    expires = "; expires=" + date;
    document.cookie = syncCookie + "=" + value + expires + "; path=/";
}
function getSyncCookie() {
    let name = syncCookie + "=";
    let decodedCookie = decodeURIComponent(document.cookie);
    let ca = decodedCookie.split(';');
    for (let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) == ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
        }
    }
    return "";
}
function syncCustomer(){
  
  if(isCustomer && exigoId < 1 && getSyncCookie() != customerId){
    console.log(exigoId);
    setSyncCookie(customerId);
    exigoId = -1;
    var data = {
      Id: customerId,
      exigoId: exigoId,
      customerTypeId: exigoCustomerTypeId,
      webalias: exigoWebalias,
      currentWebalias: getCookie(referralCookieName),
      currentReferral: _referral,
      shopUrl: shopUrl
    }
    $.ajax({
      url: apiUrl + '/api/customer/CreateCustomer',
      type: "GET",
      data: data,
      success: function(response){
        console.log(response);
        refreshLoginCookie();
      }
    });
  }
}
// function syncCustomerData(){
//   if(isCustomer && exigoId > 0){
//     var data = {
//       Id: customerId,
//       exigoId: exigoId,
//       customerTypeId: exigoCustomerTypeId,
//       webalias: exigoWebalias,
//       currentWebalias: getCookie(referralCookieName),
//       currentReferral: _referral,
//       shopUrl: shopUrl
//     }
//     $.ajax({
//       url: apiUrl + '/api/customer/SyncCustomer',
//       type: "GET",
//       data: data,
//       success: function(response){
//   console.log(response);
//         refreshLoginCookie();
//       }
//     });
//   }
// }
function createShareCartLink(){
  return fetch('/cart.js')
    .then(function (response) {
        return response.json();
    })
    .then(function (json) {
      var url = storePublicUrl +"/cart/"; //"https://" + shopUrl + "/cart/";
      for(let i = 0; i < json.items.length; i++) {
        url = url + json.items[i].variant_id;
        url = url + ":" + json.items[i].quantity;
        if(i < (json.items.length - 1)){
          url = url + ","
        }
      }
      url = url + "?storefront=true";
      if(isCustomer){
        url = url + "&ref=" + exigoWebalias;
      }
      try {
        copy(url);
      } catch (err) {
        alert('Failed to copy!', err);
      }
    })
    .catch(function (error) {
        console.error('Error retreiving cart: ', error);
        return "";
    });
}
function copy(text) {
    return new Promise((resolve, reject) => {   
        navigator.clipboard.writeText(text).then(() => {
          $("#cart-link-copied").show();
          setTimeout(function() {
            $("#cart-link-copied").fadeOut(500);
          }, 2000);
        }).catch(function (error) {
          $("#cart-url").val(text);
          $("#cart-url").show();
          $(".copy-cart-link").show();
          $(".share-cart-link").hide();
          alert("Cart url generated. Please click the copy link button to copy to your clipboard");
        });
    });
    
}


async function fetchCart() {
    var response = await fetch('/cart.js');
    return await response.json();
  }
async function forceEnrollment(){
  var enrollmentStep = $("#enrollment-flow-step").val();
  if(enrollmentStep == undefined){
    var cart = await fetchCart();
    if (cart.attributes.CustomerType != undefined) {
      var selection = confirm("Moving out of the enrollment will clear your cart");
      if(selection) {
        clearEnrollmentFlow(window.location.href);
      } else {
        window.location = history.back();
      }
    }
  }
}
function clearEnrollmentFlow(url){
  $.ajax({
    type: "POST",
    url: '/cart/clear.js',
    success: function(){
      var nullHash = {
          'Birthday': null,
          'Webalias': null,
          'CustomerType': null,
          'Email': null
      };
      $.ajax({
          type: "POST",
          url: '/cart/update.js',
          data: {attributes:nullHash},
          dataType: 'json',
          success: function(){
            if(url == undefined){
              return;
            } else {
              var original = getUrlVars()["original"];
              if(original != undefined){
                url = url.replace(getUrlVars()["ref"], getUrlVars()["original"]);
              }
              window.location = url;
            }
          }
      });
    },
      dataType: 'json'
    
    });
  }

function setSettings(){
    apiUrl = Exigo.Settings.ApiUrl;
    checkoutUrl = Exigo.Settings.CheckoutUrl;
    shopUrl = Exigo.Settings.ShopUrl;
    storePublicUrl = Exigo.Settings.StorePublicUrl;
    debugApiUrl = Exigo.Settings.DebugApiUrl;
    debugCheckoutUrl = Exigo.Settings.DebugCheckoutUrl;
    sharedKey = Exigo.Settings.SharedKey;
    backofficeUrl = Exigo.Settings.BackofficeUrl;
    loginCookie = Exigo.Settings.LoginCookie;
    syncCookie = Exigo.Settings.SyncCookie;
    silentLoginUrl = (Exigo.Settings.SilentLoginUrl == undefined);
    referralCookieName = (Exigo.Settings.ReferralCookieName == undefined) ? "refId" : Exigo.Settings.ReferralCookieName;
    referralParameter = (Exigo.Settings.ReferralParameter == undefined) ? "ref" : Exigo.Settings.ReferralParameter;
    defaultWebalias = (Exigo.Settings.DefaultWebalias == undefined) ? "theonglobal" : Exigo.Settings.DefaultWebalias;
    enableEnrollerSearch = (Exigo.Settings.EnableEnrollerSearch == undefined) ? false : Exigo.Settings.EnableEnrollerSearch;
    if(Exigo.Settings.Checkout != undefined){
      useCheckout = (Exigo.Settings.Checkout.UseCheckout == undefined) ? false : Exigo.Settings.Checkout.UseCheckout;
      if(useCheckout)
      {
        cartFormId = (Exigo.Settings.Checkout.CartFormId == undefined) ? "cart" : Exigo.Settings.Checkout.CartFormId;
        clearCartbyParameter = (Exigo.Settings.Checkout.ClearCartbyParameter == undefined) ? false : Exigo.Settings.Checkout.ClearCartbyParameter;
        hasClearCartShopifyPage = (Exigo.Settings.Checkout.HasClearCartShopifyPage == undefined) ? false : Exigo.Settings.Checkout.HasClearCartShopifyPage;
        restrictEnrollmentKits = (Exigo.Settings.Checkout.RestrictEnrollmentKits == undefined) ? false : Exigo.Settings.Checkout.RestrictEnrollmentKits;
        enrollmentKitsAllowed = (Exigo.Settings.Checkout.EnrollmentKitsAllowed == undefined) ? false : Exigo.Settings.Checkout.EnrollmentKitsAllowed;
        useCheckoutForEnrollment = (Exigo.Settings.Checkout.UseCheckoutForEnrollment == undefined) ? false : Exigo.Settings.Checkout.UseCheckoutForEnrollment;
        useCheckoutForSubscriptions = (Exigo.Settings.Checkout.UseCheckoutForSubscriptions == undefined) ? false : Exigo.Settings.Checkout.UseCheckoutForSubscriptions;
      }
    }
  if(Exigo.Settings.Enrollment != undefined){
      useEnrollment = (Exigo.Settings.Enrollment.Enable == undefined) ? false : Exigo.Settings.Enrollment.Enable;
      if(useEnrollment)
      {
        forceEnrollmentFlow = (Exigo.Settings.Enrollment.ForceEnrollmentFlow == undefined) ? false : Exigo.Settings.Enrollment.ForceEnrollmentFlow;
      }
    }
}
function initialize(){
  document.addEventListener("DOMContentLoaded", function (e) {
    console.log("ExigoScript running");
    setSettings();
    setDebugCookie();
    setDebug();
    syncCustomer();
    // syncCustomerData();
    setReferralCookie();
    setEnroller();
    currentLocationNoRef = removeURLParameter(location.href, referralParameter);
    addReferralToUrl();
    insertNotesCreateCustomerForm();
    setEnrollerSearchLogic();
    setEnrollerSearch();
    //setCartEnrollerSearch();
    //setEventListeners();
    setTimeout(function() {
      logCart();
    }, 2000);
    if(useEnrollment){
      if(forceEnrollmentFlow){
        forceEnrollment();
      }
    }
    if(enableEnrollerSearch){
      setEnrollerSearch();
    }
    if(useCheckout)
    {
      setCheckoutEventListeners();
      clearCartLogic();
    }
    $(".share-cart-link").on("click", function(){
      createShareCartLink();
    });
    $(".copy-cart-link").on("click", function(){
      var text = $("#cart-url").val();
      copy(text);
    });
  });
}
function logCart() {
  console.log("log cart");
    return fetch('/cart.js')
        .then(function (response) {
            return response.json();
        })
        .then(function (json) {
          console.log(json);
        })
        .catch(function (error) {
            console.error('Error retreiving cart: ', error);
            return "";
        });
}
async function webaliasAwailable(callBack, webAlias){
  $.ajax({
    url: apiUrl + '/api/Customer/IsWebaliasAvailable?Webalias=' + webAlias + '&shopUrl=' + shopUrl,
    type: "GET",
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json'
    },
    success: function(response){
      callBack(response);
    }
  });
}
async function emailAvailable(callBack, email){
  $.ajax({
    url: apiUrl + '/api/Customer/IsEmailAvailable?email=' + email + '&shopUrl=' + shopUrl,
    type: "GET",
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json'
    },
    success: function(response){
      callBack(response);
    }
  });
}
function createCustomerShopify(callBack, data){
  $.ajax({
    url: apiUrl + '/api/customer/CreateCustomerInShopify?shopUrl=' + shopUrl,
    type: "POST",
    data: JSON.stringify(data), 
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json'
    },
    success: function(response){
      callBack(response);
    }
  });
}
function loginCustomer(callBack, data){
  $.ajax({
    url: "/account/login",
    type: "POST",
    data: data.serialize(), 
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json'
    },
    success: function(response){
      callBack(response);
    }
  });
}
//End Basic Functions

//Exigo Checkout Functions
var orderTotalNew = 0;
var autoOrderTotalNew = 0;
async function getCartJsonString(){
  const cart = await fetch('/cart.js');
  const json = await cart.json();
  json.items.map(function(item) { 
      delete item.product_description; 
      return item; 
  });
  return json;        
}
function setPrices(){
  hasPack = false;
  hasSubscription = false;
  return fetch('/cart.js')
    .then(function (response) {
        return response.json();
    })
    .then(function (json) {
      for(let i = 0; i < json.items.length; i++) {
        let obj = json.items[i];
        if(obj.properties != null) {
          if(obj.properties.ordertype == "enrollmentpack"){
            hasPack = true;
          } else if(obj.properties.ordertype == "autoorder"){
            hasSubscription = true;
          }
        }
      }
      if(hasSubscription && !hasPack){
        priceType = 2;
        priceTypeWithCurrency = priceType + "_" + currencyCode;
        getProductPrices();
      } else if (hasPack){
        priceType = 3;
        priceTypeWithCurrency = priceType + "_" + currencyCode;
        getProductPrices();
      }
      calculateCart();
    })
    .catch(function (error) {
        console.error('Error retreiving cart: ', error);
        return "";
    });
}
function GoToCheckout() {
  hasPack = false;
  hasSubscription = false;
  return fetch('/cart.js')
    .then(function (response) {
        return response.json();
    })
    .then(function (json) {
      for(let i = 0; i < json.items.length; i++) {
        let obj = json.items[i];
        if(obj.properties != null) {
          if(obj.properties.ordertype == "enrollmentpack"){
            hasPack = true;
          }
          if(obj.properties.ordertype == "autoorder"){
            hasSubscription = true;
          }
        }
      }
      var referral = getCookie(referralCookieName);
      if(useCheckoutForEnrollment && hasPack) {
        getCartJSON();
      } else {
        window.location = "/checkout";
      }
    })
    .catch(function (error) {
        console.error('Error retreiving cart: ', error);
        return "";
    });
}
function createDiscountedShopifyCheckout() {
    return fetch('/cart.js')
        .then(function (response) {
            return response.json();
        })
        .then(function (json) {
          json.items.map(function(item) { 
              delete item.product_description; 
              return item; 
          });
          var referral = getCookie(referralCookieName);
          var jsonstring = JSON.stringify(json);
          var cart = jsonstring.replace("'s", "s");
          var data = {
              Cart: JSON.stringify(json),
              Country: countryCode,
              Token: exigoSilentLoginToken,
              ShopUrl: Exigo.Settings.ShopUrl,
              CustomerId: customerId,
              CustomerTypeId: customerType,
              PointAccountId: pointAccountId
            };
          console.log(data);
          $.ajax({
            url: apiUrl + '/api/shopping/createDraftOrder',
            type: "POST", 
            headers: {
              Accept: 'application/json',
              'Content-Type': 'application/json'
            },
            data: JSON.stringify(data),
            success: function(response){
              window.location = response;
            }
          });
        })
        .catch(function (error) {
            console.error('Error retreiving cart: ', error);
            return "";
        });
}
function getCartJSON() {
    return fetch('/cart.js')
        .then(function (response) {
            return response.json();
        })
        .then(function (json) {
          json.items.map(function(item) { 
              delete item.product_description; 
              delete item.title;
              delete item.featured_image.alt;
              item.product_title = item.product_title.replace(/"|'/g,'');
              return item; 
          });
          var referral = getCookie(referralCookieName);
          var url = checkoutUrl + '/' + referral;
          console.log(json);
          var form = $('<form action="' + url + '" method="post">' +
            "<input type='text' name='token' value='" + getLoginCookie() + "' />" +
            "<input type='text' name='cart' value='" + JSON.stringify(json) + "' />" +
            '<input type="text" name="countryCode" value="' + countryCode + '" />' +
            '<input type="text" name="shopUrl" value="' + Exigo.Settings.ShopUrl + '" />' +
            '<input type="text" name="cultureCode" value="' + cultureCode + '" />' +
            '</form>');
          $('body').append(form);
          form.submit();
        })
        .catch(function (error) {
            console.error('Error retreiving cart: ', error);
            return "";
        });
}
function getProductPrices() {
  $(".exigo-price").each(function(){
    var sku = $(this).data("sku");
    $.ajax({
      url: apiUrl + '/api/context/getProductPrice?pricetype=' + priceTypeWithCurrency + '&sku=' + sku + '&shopUrl=' + shopUrl,
      type: "GET",
      success: function(response){
        $(".exigo-product-price-" + sku).html("$" + response.price);
        $(".preferred-product-price-" + sku).html("$" + response.preferredPrice);
        $(".wholesale-product-price-" + sku).html("$" + response.wholesale);
        $(".retail-product-price-" + sku).html("$" + response.retail);
        $(".cv-" + sku).html("$" + response.cv);
        $(".bv-" + sku).html("$" + response.bv);
        $(".qv-" + sku).html("$" + response.qv);
      }
    });
  });
  if(priceType > 1){
    $(".Price--compareAt").show();
  }
}
async function calculateCart() {
  var exigoCart = $("#exigo-cart");
  if(exigoCart != undefined){
    if(priceType > 1) {
      const cart = await getCartJsonString();
      orderTotalNew = 0;
      var points = cart.attributes.points;
      if(points != undefined) {
        orderTotalNew = -points;
      }
      for(var i in cart.items){
        var item = cart.items[i];
        if(item.selling_plan_allocation == undefined) {
          setCartPrice(item); 
        }
      }
      $(".additional-checkout-buttons").hide();
      $("#paypal-animation-container").hide();
    }
  }
}
function setCartPrice(item){ 
  $.ajax({
    url: apiUrl + '/api/context/calculateCartItem?pricetype=' + priceTypeWithCurrency + "&sku=" + item.sku + "&quantity=" + item.quantity + '&shopUrl=' + shopUrl,
    type: "GET",
    success: function(response){
      orderTotalNew = orderTotalNew + response.finalPrice;
      $(".exigo-price-" + item.sku).html("$" + response.price);
      $(".exigo-cart-finalprice-" + item.sku).html("$" + response.finalPrice.toFixed(2));
      $(".exigo-cart-total").html("$" + orderTotalNew.toFixed(2));
      if(pointsAvailable > 0 && pointsAvailable >= orderTotalNew){
        $("#exigo-pointstospend").attr({
           "max" : orderTotalNew
        });
      } else {
        $("#exigo-pointstospend").attr({
           "max" : pointsAvailable
        });
      }
    }
  });
}
function clearCartLogic(){
  if(Exigo.Settings.Checkout. ClearCartbyParameter && window.location.href.includes("clearcart=true")) {
    clearCart();
    window.location = window.location.href.replace("clearcart=true", "");
  }
  if(Exigo.Settings.Checkout.HasClearCartShopifyPage && window.location.href.includes("pages/clearcart")){
    clearCart();
    window.location = appUrl + "/" + getCookie(cookieName) + "/shopifycheckout/ordercomplete";
  }
}
function setCheckoutEventListeners(){
  $('#' + cartFormId).on("submit", function (e) {
      e.preventDefault();
      GoToCheckout();
  });
  $('[data-role="add-to-order"]').on("click", function (e) {
    var orderType = $("#ordertype").val();
    if(orderType == "enrollmentpack"){
      Checkforenrollmentkit(this);
    } else {
      addToCart(this);
    }
  });
  $('[data-role="remove-kit"').on("click", function(){
    clearCart();
  });
  $('input[name="exigo-ordertype"]').on("change", function(){
    var orderType = $("input[name='exigo-ordertype']:checked").val();
    $("#ordertype").val(orderType);
    if(orderType == "autoorder") {
      $("#autoorderFrequencySelector").show();
      $('#frequencyType').attr('name', 'properties[frequencytype]');
      $("#frequencyName").attr('name', 'properties[frequencyname]');
    } else {
      $("#autoorderFrequencySelector").hide();
      $('#frequencyType').attr('name', '');
      $("#frequencyName").attr('name', '');
    }
  });
  $("#autorderFrequency").on("change", function(){
     var typeId = $(this).val();
     var name = $("#autorderFrequency option:selected").text();
      $("#frequencyType").val(typeId);
      $("#frequencyName").val(name);
  });
}
function addToCart(button){
  $.ajax({
    type: 'POST', 
    url: '/cart/add.js',
    dataType: 'json', 
    data: $(button).closest('form').serialize(),
    success: function(){
        window.location = "/cart"; 
      }
   });
}
function Checkforenrollmentkit(button) {
  var hasPack = false;
  var count = 0
  return fetch('/cart.js')
    .then(function (response) {
        return response.json();
    })
    .then(function (json) {
      for(let i = 0; i < json.items.length; i++) {
        let obj = json.items[i];
        if(obj.properties.ordertype == "enrollmentpack"){
          hasPack = true;
          $.ajax({
            type: 'POST',
            url: '/cart/change.js',
            dataType: 'json',
            data: {
                quantity: 0,
                id: obj.id
            },
            success: function (data){
              addToCart(button);
            }
          });
        }
      }
      if(!hasPack) {
        $.ajax({
          type: "POST",
          url: '/cart/clear.js',
          success: function(){
            addToCart(button);
          },
          dataType: 'json'
        });
      }
    })
    .catch(function (error) {
        console.error('Error retreiving cart: ', error);
        return "";
    });
}
function clearCart(){
  $.ajax({
    type: "POST",
    url: '/cart/clear.js',
    success: function(){
      window.location = window.location;
    },
    dataType: 'json'
  });
}
//End Exigo Checkout Functions

//start affiliate points
function getPoints(callBack){
  $.ajax({
    url: apiUrl + '/api/Affiliate/GetCustomerPointaccountBalance?token=' + getLoginCookie() + '&shopUrl=' + shopUrl,
    type: "GET",
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json'
    },
    success: function(response){
      callBack(response);
    }
  });
}
function getAllAffiliateRewards(callBack){
  $.ajax({
    url: apiUrl + '/api/Affiliate/GetAffiliateRewards?token=' + getLoginCookie() + '&shopUrl=' + shopUrl,
    type: "GET",
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json'
    },
    success: function(response){
      callBack(response);
    }
  });
}
function createAffiliateReward(callBack, amount){
  var url = url = apiUrl + '/api/Affiliate/CreatePointRedemptionCode?amount=' + amount + '&token=' + getLoginCookie() + '&shopUrl=' + shopUrl + "&useGraphQL=true";
  $.ajax({
    url: url,
    type: "POST",
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json'
    },
    success: function(response){
      callBack(response);
    }
  });
}
function getPointAccountHistory(callBack){
  $.ajax({
    url: apiUrl + '/api/Affiliate/GetPointAccountHistory?token=' + getLoginCookie() + '&shopUrl=' + shopUrl,
    type: "GET",
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json'
    },
    success: function(response){
      callBack(response);
    }
  });
}
//end affiliate points
